export default __webpack_public_path__ + "static/media/Rosella_CV.42339318.pdf";